import SpriteSymbol from "../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "play",
  "use": "play-usage",
  "viewBox": "0 0 11 13",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 11 13\" id=\"play\"><path d=\"M.976.263l9.87 6.285-9.87 6.286z\" fill=\"#214263\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./icons/play.svg
// module id = 1011
// module chunks = 0